import axios from "axios";
import { globalConfig } from "@/v2/core";

const client = axios.create({
  baseURL: globalConfig.inboxWebsocketAddress,
});

export const httpInbox = client;
